import { render, staticRenderFns } from "./event-password-delete-confirm-modal.vue?vue&type=template&id=8bafe7b8&scoped=true"
import script from "./event-password-delete-confirm-modal.vue?vue&type=script&lang=js"
export * from "./event-password-delete-confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./event-password-delete-confirm-modal.vue?vue&type=style&index=0&id=8bafe7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bafe7b8",
  null
  
)

export default component.exports